<template>
  <transition name="notification">
    <div class="alert" :class="`alert-${notification.mode}`" role="alert" v-if="notification.message">
      {{ notification.message }}
      <p class="mb-0"><slot /></p>
    </div>
  </transition>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'Notification',
  computed: {
    ...mapState(['notification'])
  }
}
</script>
